import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import type { UserActivityType } from '../types';

interface ISummaryTableProps {
  data: UserActivityType | null;
  isLoading: boolean;
  isError: boolean;
}

const SummaryTable: React.FC<ISummaryTableProps> = ({ data, isLoading, isError }) => {
  if (isLoading) {
    return (
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography>Loading...</Typography>
      </Paper>
    );
  }

  if (isError) {
    return (
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography color="error">Cannot load user summary</Typography>
      </Paper>
    );
  }

  const getPlanStatus = (quitPlanCompleted: boolean | undefined) => {
    if (typeof quitPlanCompleted === 'boolean') {
      return quitPlanCompleted ? 'Yes' : 'No';
    }
    return '';
  };

  const interactionsCount = (data?.userMessagesCnt || 0) + (data?.botMessagesCnt || 0);

  return (
    <TableContainer component={Paper} elevation={3} sx={{ mb: 3 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>User ID</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>Days Enrolled</TableCell>
            <TableCell>User Messages</TableCell>
            <TableCell>Bot Messages</TableCell>
            <TableCell># Interactions</TableCell>
            <TableCell>Day since last message</TableCell>
            <TableCell>Quit-Plan Completed?</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{data?.userId}</TableCell>
            <TableCell>
              {data?.createdAt && new Date(data?.createdAt).toLocaleDateString()}
            </TableCell>
            <TableCell>{data?.daySinceFirstMessage}</TableCell>
            <TableCell>{data?.userMessagesCnt}</TableCell>
            <TableCell>{data?.botMessagesCnt}</TableCell>
            <TableCell>{interactionsCount}</TableCell>
            <TableCell>{data?.daySinceLastMessage}</TableCell>
            <TableCell>{getPlanStatus(data?.quitPlanFinished)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SummaryTable;
